import {createStore,combineReducers, applyMiddleware} from 'redux';
import { thunk } from 'redux-thunk';
import createReducer from '../redux/reducers';

const rootReducer = createReducer();

export const store = createStore(rootReducer,applyMiddleware(thunk))